// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-debt-button__k3dFQ{position:absolute;z-index:2;bottom:10px;right:0px}`, "",{"version":3,"sources":["webpack://./src/components/debts-table/debts-table/components/debts-desktop-table/DebtsDesktopTable.module.scss"],"names":[],"mappings":"AAAA,wBACC,iBAAA,CACA,SAAA,CACA,WAAA,CACA,SAAA","sourcesContent":[".add-debt-button {\n\tposition: absolute;\n\tz-index: 2;\n\tbottom: 10px;\n\tright: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add-debt-button": `add-debt-button__k3dFQ`
};
export default ___CSS_LOADER_EXPORT___;
